// extracted by mini-css-extract-plugin
export default {"cardContainer":"card-container__card-container__SPsy4","pageHeightCardContainer":"card-container__page-height-card-container__IJI2v"};